import React, { useState } from "react";
import "./ForgotForm.css";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { forgotPassword } from "../../../context/Slice/loginSlice";

const ForgotForm = ({ isOpen, onClose }) => {
  let navigate = useNavigate();
  const dispatch = useDispatch();

  const [email, setEmail] = useState("");
  const [mobile_number, setmobileNumber] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(email)) {
      newErrors.email = "Please enter a valid email.";
    }
    if (mobile_number.length < 10) {
      newErrors.mobile_number = "Phone Number must be at least 10 characters long.";
    }
    if (newPassword.length < 8) {
      newErrors.newPassword = "Password must be at least 8 characters long.";
    }
    if (newPassword !== confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      const response = await dispatch(
        forgotPassword({ email, mobile_number,newPassword, confirmPassword })
      );
      if (response.payload.status === 200) {
        navigate("/Forgot-Otp", {
          state: { email, mobile_number ,newPassword, confirmPassword },
        });
      } else {
        console.log("Something went wrong with the password reset.");
      }
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <button className="close-button" onClick={onClose}>
          &times;
        </button>
        <div className="forgot-password-reset-box">
          <div className="forgot-logo-container">
            <img
              src="/assets/Images/logo.png"
              alt="Logo"
              className="forgot-logo"
            />
          </div>
          <h2>Trouble logging in?</h2>
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              placeholder="Enter Your Email"
              className="forgot-input-field"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <input
              type="number"
              placeholder="Enter Your Phone Number"
              className="forgot-input-field"
              value={mobile_number}
              onChange={(e) => setmobileNumber(e.target.value)}
            />
            {errors.email && <p className="forgot-error">{errors.email}</p>}
            <div className="forgot-password-container">
              <input
                type={showNewPassword ? "text" : "password"}
                placeholder="New Password"
                className="forgot-input-field"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
              <button
                type="button"
                className="forgot-toggle-password"
                onClick={() => setShowNewPassword(!showNewPassword)}
              >
                {showNewPassword ? "Hide" : "Show"}
              </button>
            </div>
            {errors.newPassword && (
              <p className="forgot-error">{errors.newPassword}</p>
            )}
            <div className="forgot-password-container">
              <input
                type={showConfirmPassword ? "text" : "password"}
                placeholder="Confirm Password"
                className="forgot-input-field"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              <button
                type="button"
                className="forgot-toggle-password"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              >
                {showConfirmPassword ? "Hide" : "Show"}
              </button>
            </div>
            {errors.confirmPassword && (
              <p className="forgot-error">{errors.confirmPassword}</p>
            )}
            <button type="submit" className="forgot-send-link-button">
              Send
            </button>
          </form>
          <div className="forgot-back-to-login-container">
            <a className="forgot-back-to-login" onClick={onClose}>
              Back to login
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotForm;
